// extracted by mini-css-extract-plugin
export default {"root":"NotFound_root__FNDAi","decription":"NotFound_decription__4uM-V"};